import { render, staticRenderFns } from "./ReviewHall.vue?vue&type=template&id=171a1e1d"
import script from "./ReviewHall.vue?vue&type=script&lang=js"
export * from "./ReviewHall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports